import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("mouseenter", this.highlight.bind(this))
    this.element.addEventListener("mouseleave", this.unhighlight.bind(this))
  }

  highlight() {
    this.element.querySelector("div").classList.remove("border-gray-800")
    this.element.querySelector("div").classList.add("border-red-500")
  }

  unhighlight() {
    this.element.querySelector("div").classList.remove("border-red-500")
    this.element.querySelector("div").classList.add("border-gray-800")
  }
}

